/* eslint-disable yoda */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter
} from '@ps-design-system/components/Dialog';
import { Button } from '@ps-design-system/components/Button';
import { Text } from '@ps-design-system/components/Text';
import { RadioGroup, RadioGroupItem } from '@ps-design-system/components/RadioGroup';
import { Input } from '@ps-design-system/components/Input';

import { usePauseModal } from '../context/PauseModalContext';

const PauseModalStepTwo = ({ onNextStep, onCancel, reason, setReason, other, setOther }) => {
  const { intl } = usePauseModal();

  const handleInputChange = (e) => {
    setOther(e.target.value);
  };

  return (
    <>
      <DialogHeader
        className="pause-modal-step-container"
        headerAlignment="left"
        showCloseButton
      >
        <DialogTitle className="pause-modal-dialog-header">
          <FormattedMessage id="pause.modal.step_two_title" defaultMessage="Select reason for pause"/>
        </DialogTitle>
      </DialogHeader>
      <DialogBody>
        <Text typeface="body-2-m" className="reason-title">
          <FormattedMessage id="pause.modal.why" defaultMessage="Why are you pausing?"/>
        </Text>
        <RadioGroup
          className="pause-radio-group"
          defaultValue=""
          value={reason}
          onValueChange={setReason}
        >
          <RadioGroupItem
            className="radio-label"
            value="renovations"
            id="pause-radio-renovations"
            label={intl.formatMessage({
              id: 'pause.reason.renovations',
              defaultMessage: 'Renovations'
            })}
            data-testing-id="pause-radio-renovations"
          />
          <RadioGroupItem
            className="radio-label"
            value="vacation"
            id="pause-radio-vacation"
            label={intl.formatMessage({
              id: 'pause.reason.vacation',
              defaultMessage: 'Going on vacation'
            })}
            data-testing-id="pause-radio-vacation"
          />
          <RadioGroupItem
            className="radio-label"
            value="fully_booked"
            id="pause-radio-booked"
            label={intl.formatMessage({
              id: 'pause.reason.booked',
              defaultMessage: 'Fully booked'
            })}
            data-testing-id="pause-radio-booked"
          />
          <RadioGroupItem
            className="radio-label"
            value="changing_listing"
            id="pause-radio-changes"
            label={intl.formatMessage({
              id: 'pause.reason.changes',
              defaultMessage: 'Making changes to my listing'
            })}
            data-testing-id="pause-radio-changes"
          />
          <RadioGroupItem
            className="radio-label"
            value="change_staffing"
            id="pause-radio-staffing"
            label={intl.formatMessage({
              id: 'pause.reason.staffing',
              defaultMessage: 'Change in staffing'
            })}
            data-testing-id="pause-radio-staffing"
          />
          <RadioGroupItem
            className="radio-label"
            value="not_hosting"
            id="pause-radio-host"
            label={intl.formatMessage({
              id: 'pause.reason.host',
              defaultMessage: 'Don’t want to host right now'
            })}
            data-testing-id="pause-radio-host"
          />
          <RadioGroupItem
            className="radio-label"
            value="other"
            id="pause-radio-other"
            label={intl.formatMessage({
              id: 'pause.reason.other',
              defaultMessage: 'Other'
            })}
            data-testing-id="pause-radio-other"
          />
        </RadioGroup>
        <div className="other-input">
          <Input
            placeholder={intl.formatMessage({
              id: 'pause.reason.different',
              defaultMessage: 'Different reason'
            })}
            fullWidth={true}
            value={other}
            onChange={handleInputChange}
            onFocus={() => setReason('other')}
            attributes={{ 'data-testing-id': 'other-input-field' }}
          />
          <Text typeface="caption-2" className="input-description">
            <FormattedMessage id="pause.reason.max" defaultMessage="Maximum 300 characters"/>
          </Text>
        </div>
      </DialogBody>
      <DialogFooter className="pause-dialog-footer">
        <div className="footer-container">
          <div>
            <Button
              variant="underline"
              onClick={onCancel}
              attributes={{ 'data-testing-id': 'pause-modal-cancel' }}
            >
              <FormattedMessage id="pause.modal.cancel" defaultMessage="Cancel"/>
            </Button>
          </div>
          <div className="footer-button">
            <Button
              onClick={onNextStep}
              disabled={!reason}
              attributes={{ 'data-testing-id': 'pause-modal-continue' }}
            >
              <FormattedMessage id="pause.modal.continue" defaultMessage="Continue" />
            </Button>
          </div>
        </div>
      </DialogFooter>
    </>
  );
};

PauseModalStepTwo.propTypes = {
  onNextStep: PropTypes.func,
  onCancel: PropTypes.func,
  reason: PropTypes.string,
  setReason: PropTypes.func,
  other: PropTypes.string,
  setOther: PropTypes.func
};

PauseModalStepTwo.defaultProps = {
  onNextStep: () => {},
  onCancel: () => {},
  reason: '',
  setReason: () => {},
  other: '',
  setOther: () => {}

};

export default PauseModalStepTwo;
